export default {
    atmosInitialized: (state) => state.atmosInitialized,
    atmosSubscription: (state) => state.atmosSubscription,
    atmosSubscriptions: (state) => state.atmosSubscriptions,
    atmosAppTypes: (state) => state.atmosAppTypes,
    atmosApps: (state) => state.atmosApps,
    atmosAppsRefreshing: (state) => state.atmosAppsRefreshing,
    
    showPrereleases: (state) => state.showPrereleases,
    showVersions: (state) => state.showVersions,
}